"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviaImagem = void 0;
var previaImagemModule = require('./PreviaImagem.module.scss');
var react_1 = __importDefault(require("react"));
var Cores_1 = require("../Cores/Cores");
var Icone_1 = require("../Icone/Icone");
var PreviaImagem = function (_a) {
    var imageSource = _a.imageSource;
    var _b = react_1.default.useState(imageSource), imageSrc = _b[0], setImageSrc = _b[1];
    return (react_1.default.createElement(react_1.default.Fragment, null, imageSrc ?
        react_1.default.createElement("img", { src: imageSrc, alt: "Pr\u00E9via do Relat\u00F3rio PDF", className: previaImagemModule.imagePreview })
        :
            react_1.default.createElement("div", { className: "".concat(previaImagemModule.placeholder) },
                react_1.default.createElement(Icone_1.Icone, { nome: "image", largura: "200px", altura: "200px", cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU500 }))));
};
exports.PreviaImagem = PreviaImagem;
